module.exports = __webpack_public_path__ + "media/images/gift_plan/bubble-img-introduction-96fed174311d0957cf58d7fb3b99b8a5.png";